// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertTriggerPanel-module__container__20PnC","column-1":"AlertTriggerPanel-module__column-1__3QOmW","spinner":"AlertTriggerPanel-module__spinner__3Qt3c"};